module.exports = "//static.hsappstatic.net/ui-addon-upgrades/static-9.18395/js/img/valuePropModals/TeamNoAccess/ValueProp2.svg"